/** AbortError is returned when fetch was aborted intentionally via AbortSignal */
export function isAbortError(error) {
    // cannot use expression 'error instanceof DOMException', because msw tests return custom AbortError error
    return (error === null || error === void 0 ? void 0 : error.name) === 'AbortError';
}
//# sourceMappingURL=isAbortError.js.map